import React, { useState, useMemo } from 'react'
import { Button, Modal, Select, InputNumber, message } from "antd"
import { v4 as uuidV4 } from 'uuid'
import { saveDelivery } from "../../../../services/api/3dApi"

const ChangeSewingGroups = (props) => {
    const { isOpen = false, onClose, loading = false, partner = {}, sewingGroupsData = [], batchId, totalItems = 0, reload } = props
    const { groups = [], has_groups = false } = { ...partner }
    const listGroups = useMemo(() => has_groups ? groups : [], [has_groups, groups])

    const [sewingGroups, setSewingGroups] = useState(!!sewingGroupsData.length ? 
        sewingGroupsData.map(g => ({...g, _idx: uuidV4()})) : [
        {
            id: null,
            quantity: null,
            _idx: uuidV4()
        },
    ])


    const _handleChangeSewingGroup = (field, value, idx) => {
        setSewingGroups(preState => {
            return preState.map(item => {
                if (idx === item._idx) {
                    return { ...item, [field]: value }
                }

                return item
            })
        })
    }

    const _handleDeleteGroupSewing = (idx) => {
        setSewingGroups(preState => preState.filter(item => item._idx !== idx))
    }

    const _handleAddGroupSewing = () => {
        setSewingGroups(preState => [...preState, { id: null, quantity: null, _idx: uuidV4() }])
    }

    const _handleDelivery = async () => {
        try {
            const payload = {
                force_update: true
            }
            if(sewingGroups.some(item => !item.id || !item.quantity)) throw new Error("Cần nhập đủ nhóm may và số lượng item.")

            const checkQuantity = sewingGroups.some(group => !!group.quantity && group.quantity < 1)
            if (checkQuantity) throw new Error("Số lượng item giao cho nhóm sản xuất phải ≥ 1.")

            // const totalQuantity = sewingGroups.reduce((acc, item) => acc + (+item.quantity || 0), 0) || 0
            // if (+totalQuantity !== +totalItems) throw new Error("Tổng số item giao may phải bằng số item trong lô.")

            const newSewingGroups = sewingGroups.map(group => ({ id: group.id, quantity: +group.quantity })) || []

            if (!!newSewingGroups.length) payload.groups = newSewingGroups

            const { data = {} } = await saveDelivery(batchId, payload)

            const { success, error } = { ...data }

            if (!success) throw new Error(error)

            message.success('Giao may thành công.')
            handleCancle()
            if(typeof reload === 'function') reload()
        } catch (error) {
            message.error(error.message)
        }
    }

    const handleCancle = () => {
        onClose()
    }

    return (
        <div className='ChangeSewingGroups'>
            <Modal
                title="Thay đổi nhóm giao may"
                visible={isOpen}
                onCancel={handleCancle}
                width={600}
                footer={[
                    <div key='select' className='d-flex justify-content-between align-items-center'>
                        <Button key="back" onClick={handleCancle}>
                            Hủy
                        </Button>
                        <Button key="submit" type="primary" loading={loading}
                            onClick={_handleDelivery}>
                            Thay đổi
                        </Button>
                    </div>
                ]}
            >
                <div className="sewing-group-list pb-2">
                    <h4 className='mb-3'>Chọn nhóm may</h4>
                    <div className="sewing-groups">
                        {
                            sewingGroups.map((item, index) => (
                                <div className="sewing-group-item mb-3">
                                    <Select
                                        value={item.id || []}
                                        className='custom-select-sewing mr-3'
                                        placeholder="Chọn nhóm may"
                                        onChange={value => _handleChangeSewingGroup('id', value, item._idx)}
                                        style={{ width: '250px' }}
                                    >
                                        {
                                            listGroups.map(g => (
                                                <Select.Option
                                                    disabled={sewingGroups.map(s => s.id).includes(g._id)}
                                                    key={g._id}
                                                    value={g._id}
                                                >{g.name}
                                                </Select.Option>
                                            ))
                                        }
                                    </Select>

                                    <InputNumber
                                        value={item.quantity || []}
                                        className='custom-input-sewing'
                                        placeholder="Nhập số lượng"
                                        onChange={value => _handleChangeSewingGroup('quantity', +value, item._idx)}
                                        style={{ width: '250px' }}
                                    />
                                    {
                                        sewingGroups.length > 1 &&
                                        <i
                                            className="fa fa-trash ml-3 cursor-pointer"
                                            style={{ fontSize: 20, color: 'red' }}
                                            onClick={() => _handleDeleteGroupSewing(item._idx)}
                                        />
                                    }
                                </div>
                            ))
                        }
                    </div>
                    <Button type='default' style={{ marginLeft: '69%' }} onClick={_handleAddGroupSewing}>Thêm nhóm may</Button>
                </div>
            </Modal>
        </div>
    )
}

export default ChangeSewingGroups